import "../style/style.scss";

window.addEventListener("load", init);

function init() {
  const langSelectors = document.querySelectorAll("#language-selector");

  langSelectors.forEach((selector) =>
    selector.addEventListener("change", changeStore)
  );
}

function changeStore() {
  location.assign(event.target.value);
}
